import clsx from 'clsx';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HdLink } from '../../components';
import useAnalyticsTracker from '../../analytics/hooks/useAnalyticsTracker';
import { GlobalSearchTracking } from '../constants/global-search-tracking';
import { useGlobalSearchContext } from '../hooks/useGlobalSearchContext';
import { GlobalSearchStateItem } from '../interfaces/global-search';

interface GlobalSearchEntityListHeaderProps {
  showCTA?: boolean;
  entity: GlobalSearchStateItem;
  entityType: string;
}

export function GlobalSearchEntityListHeader({
  showCTA = true,
  entity,
  entityType
}: GlobalSearchEntityListHeaderProps) {
  const { closeDialog } = useGlobalSearchContext();
  const navigate = useNavigate();
  const { eventTrack } = useAnalyticsTracker();

  const { viewAllRoute, title } = entity.metaData;

  const onClickHandler = () => {
    eventTrack({
      action: GlobalSearchTracking.TRACKER_GLOBAL_SEARCH_RESULT_VIEW_ALL_CLICK,
      properties: {
        entityType
      }
    });

    navigate(viewAllRoute);
    closeDialog();
  };

  return (
    <div style={{ height: 32 }} className={clsx('justify-between center-flex-row bg-secondary')} data-id={`${entityType}-header`}>
      <span className='text-bold pl-5 text-secondary text-uppercase'>{title}</span>

      {showCTA && !!viewAllRoute ? (
        <HdLink
          direction='right'
          icon='right'
          dataId={`${entityType}-navigate`}
          className='pr-5 keyboard-nav-item'
          tabIndex={0}
          onClick={() => {
            onClickHandler();
          }}
        >
          View All
        </HdLink>
      ) : null}
    </div>
  );
}
